import React from 'react';
import PropTypes from 'prop-types';
import { FaFilePdf } from 'react-icons/fa';
import  { ButtonGroup, EditButton} from './StyledComponents.jsx';

export const BotonVerpdf = ({ Editar, row, toolText }) => {
  return (
    <ButtonGroup>
      <EditButton
        type="button"
        onClick={() => Editar(row)}
        data-tooltip-id="tooltiparriba"
        data-tooltip-content={toolText || "Ver PDF"}
      >
        <FaFilePdf />
      </EditButton>
    </ButtonGroup>
  );
};

BotonVerpdf.propTypes = {
  Editar: PropTypes.func.isRequired,
  row: PropTypes.any,
  toolText: PropTypes.string,
};